export const Config = {
  AuthApiUrl: process.env.AUTH_API_URL || 'https://api.az.hypercite.net',
  BaseApiUrl: process.env.BASE_API_URL || 'https://api.az.hypercite.net',
  RecaptchaKey: process.env.RECAPTCHA_KEY || '6Ldx7qsZAAAAAHIiezZkMYoSOwKWqmh2zTbEm0gE',
  AccessTokenKey: process.env.ACCESS_TOKEN_KEY || 'az-hypercite.access_token',
  RefreshTokenKey: process.env.REFRESH_TOKEN_KEY || 'az-hypercite.refresh_token',
};
